<template>
  <ContextMenu @update:open="isOpen = $event">
    <ContextMenuButtonTrigger v-bind="$attrs">
      <button
        type="button"
        :aria-label="$t('Select brand')"
        aria-haspopup="menu"
        :aria-expanded="isOpen"
        :class="[
          'flex h-target-minimum items-center gap-1 rounded-lg px-3 py-2 text-menu-link hover:bg-surface-selected',
          isOpen && 'bg-surface-selected',
        ]">
        <PaintBrushIcon class="size-5 flex-none" aria-hidden="true" />
        <span class="hidden lg:block text-base font-medium">{{ shopName }}</span>
        <ChevronDownIcon
          class="hidden lg:block size-4 flex-none transition-transform"
          :class="isOpen && 'rotate-180'"
          aria-hidden="true" />
      </button>
    </ContextMenuButtonTrigger>

    <ContextMenuContent class="min-w-64" :aria-label="$t('Select brand')">
      <!-- Laid out like js-lib's LanguageMenu: name on the left, tick on the right, the active row
           held in its selected background. One of a set, so menuitemradio rather than menuitem --
           only that role may carry aria-checked. -->
      <ContextMenuButton
        v-for="shop in b2shops"
        :key="shop.key"
        role="menuitemradio"
        class="justify-between gap-6"
        :class="shop.key === selectedShop && 'hover:text-neutral bg-surface-selected hover:bg-surface-selected'"
        :aria-checked="shop.key === selectedShop"
        @select="setShop(shop.key)">
        {{ shop.text }}
        <CheckIcon v-if="shop.key === selectedShop" class="size-5 flex-none" aria-hidden="true" />
      </ContextMenuButton>
    </ContextMenuContent>
  </ContextMenu>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";
import { CheckIcon, ChevronDownIcon, PaintBrushIcon } from "@heroicons/vue/24/outline";
import {
  ContextMenu,
  ContextMenuButton,
  ContextMenuButtonTrigger,
  ContextMenuContent,
} from "@xs2event/js-lib/components";
import { b2shops } from "@/brandconfig";
import { useLocalStorage } from "@vueuse/core";

// Attributes (e.g. PageHeader's @click that closes the mobile menu) go to the trigger.
defineOptions({ inheritAttrs: false });

const isOpen = ref(false);

const selectedShop = useLocalStorage("b2c_override", "xs2event");

const shopName = computed(() => b2shops.find((x) => x.key == selectedShop.value)!.text);

const setShop = (key: string) => {
  selectedShop.value = key;
  window.location.reload();
};
</script>
